<div class="checkbox-container" >
    <app-checkbox class="block mb-2"
      *ngFor="let item of list; let i = index"
      (change)="optionChanged(item.id)"
      [id]="i"
      [checked]="isSelected(item.id)"
    >
      <span class="cursor-pointer text-sm text-gray-900 font-medium"
        [ngClass]="{active: isSelected(item.id)}"
      >{{item.name}}</span>
    </app-checkbox>
</div>